import {
  IdField,
  OrderField,
  OwnerOccupierFields,
  TankAsset,
  TimestampFields,
  TitleField,
  TitleSlugFields,
} from '../types'

export enum Order {
  POPULAR = 'POPULAR',
  AZ = 'AZ',
  RECENT = 'RECENT',
  USER = 'USER',
}

export interface Link extends OwnerOccupierFields, OrderField, TitleField {
  url: string
  model: string
  foreign_id: number
}

export interface Role extends IdField, TitleSlugFields, TimestampFields {}

export interface Category extends IdField, TitleSlugFields, TimestampFields {}

export interface TileSectionCategory extends Category {
  _joinData: {
    order: number
    expanded: boolean
  }
}

export interface Subtile extends IdField, TimestampFields {
  order: number
  owner_id: number
  title?: string
  link?: Link
  tile?: Omit<Tile, '_joinData' | 'subtiles' | 'category' | 'roles'>
}

export interface Tile extends IdField, OrderField, TimestampFields {
  title: string
  title_size?: string
  content?: string
  icon?: string
  icon_asset?: TankAsset
  icon_asset_ratio?: null | '3-2' | '2-1' | '3-1' | '2-3' | '1-2'
  image?: TankAsset
  tag?: string
  background_color?: string
  text_color?: string
  category_id?: Category['id']
  category?: Category
  release_date?: string
  subtiles?: Subtile[]
  link?: Link
  information_link?: Link
  roles: Role[]
}
